import React from 'react';

import { type WalletDataType } from '@app/store/types/partner-integrations';

import './_WalletInformationTile.scss';

interface YatWalletInfoTileProps {
    walletData: WalletDataType | undefined;
}

export const YatWalletInfoTile = ({ walletData }: YatWalletInfoTileProps) => {
    return (
        <div className="yat-wallet-info-tile">
            {walletData?.logo_small && (
                <div className="yat-wallet-info-tile__logo">
                    <img src={walletData.logo_small} alt={`${walletData?.name} Logo`} />
                </div>
            )}
            <div className="yat-wallet-info-tile__content">
                <div className="yat-wallet-info-tile__title">{walletData?.name ?? 'BRD'}</div>
                <div className="yat-wallet-info-tile__currencies v2-text-fluid-sm">{`${
                    walletData?.currencies?.length ?? '0'
                } currencies`}</div>
            </div>
        </div>
    );
};
